import { render, staticRenderFns } from "./Video_showcase.vue?vue&type=template&id=271287e0"
import script from "./Video_showcase.vue?vue&type=script&lang=js"
export * from "./Video_showcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports